export default __webpack_public_path__ + "images/9544f549a4c74904ded30750f59ff37a-001-github.svg";